module.exports = __webpack_public_path__ + "503f34aa331fdd06de48b2ebeeb09f35.jpg";